import { guideSteps } from "@/mocks/guides";
import SectionHeading from "./SectionHeading";

export default function GuideSection() {
  return (
    <section id="guide" className="section-anchor w-full bg-secondary-50 border-y border-secondary-200/70">
      <div className="w-full px-4 md:px-8 py-14 md:py-20">
        <div className="max-w-7xl mx-auto">
          <SectionHeading
            eyebrow="浏览指南"
            title="四步找到你想看的潘金莲影视内容"
            desc="如果一时不知道从哪开始，可以按下面的顺序浏览：先建立整体印象，再逐步缩小范围，最后按标签或年代做对照。"
          />

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {guideSteps.map((step) => (
              <article
                key={step.id}
                className="rounded-lg bg-background-50 border border-secondary-200/70 p-5 flex flex-col"
              >
                <div className="flex items-center justify-between">
                  <span className="w-10 h-10 flex items-center justify-center rounded-md bg-secondary-500 text-background-50">
                    <i className={`${step.icon} text-lg`}></i>
                  </span>
                  <span className="font-heading text-3xl font-bold text-secondary-300">
                    {step.step}
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-base md:text-lg font-semibold text-foreground-950">
                  {step.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-700">
                  {step.desc}
                </p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}